'use client'

import { useStore } from '@/lib/store/store'
import { TocItem } from './Sidebar/Toc'
import { highlightedClauseStore } from './Clause/scroll-store'

export function TocItemWithHighlighting ({ title, index }: { title: string, index: number }) {
  const highlightedClause = useStore(highlightedClauseStore)

  return (
    <TocItem
      key={index}
      title={title}
      isHighlighted={highlightedClause === index}
      style={{
        position: 'relative',
      }}
    />
  )
}
